import { useEffect, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { fetchActiveFaqs, FaqItem } from "../api/faqService";
import FaqIcon from "../assets/imgs/png/FAQ.png";

export default function FaqButton() {
  const [faqOpen, setFaqOpen] = useState(false);
  const [faqIndex, setFaqIndex] = useState<number | null>(null);
  const [faqs, setFaqs] = useState<FaqItem[]>([]);
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth < 768 : false
  );

  // System language change forces a page reload (see avatar.tsx → handleSavePersonalization),
  // so `document.documentElement.dir` is correct by the time this component first renders.
  const isRtl =
    typeof document !== "undefined" && document.documentElement.dir === "rtl";

  useEffect(() => {
    fetchActiveFaqs().then(setFaqs).catch(() => setFaqs([]));
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const sideEdgeStyle = isRtl
    ? { left: isMobile ? "16px" : "24px" }
    : { right: isMobile ? "16px" : "24px" };
  const panelEdgeStyle = isRtl ? { left: 0 } : { right: 0 };

  return (
    <div
      style={{
        position: "fixed",
        bottom: isMobile ? "92px" : "24px",
        ...sideEdgeStyle,
        zIndex: 40,
      }}
    >
      {faqOpen && (
        <div
          style={{
            position: "absolute",
            bottom: isMobile ? "58px" : "64px",
            ...panelEdgeStyle,
            width: isMobile ? "min(288px, calc(100vw - 32px))" : "288px",
            borderRadius: "16px",
            border: "1px solid #e5e7eb",
            backgroundColor: "#fff",
            boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
          }}
        >
          <div
            style={{
              padding: "12px 16px 8px",
              fontSize: "11px",
              fontWeight: 600,
              letterSpacing: "0.05em",
              color: "#6b7280",
            }}
          >
            {isRtl ? "الأسئلة الشائعة" : "FREQUENTLY ASKED QUESTIONS"}
          </div>
          <div style={{ padding: "0 16px 8px" }}>
            {faqs.map((faq: FaqItem, i) => {
              const open = faqIndex === i;
              return (
                <div
                  key={faq.id}
                  style={{
                    padding: "8px 0",
                    borderTop: i > 0 ? "1px solid #e5e7eb" : "none",
                  }}
                >
                  <button
                    type="button"
                    onClick={() => setFaqIndex(open ? null : i)}
                    aria-expanded={open}
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: "12px",
                      textAlign: "left",
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      padding: 0,
                    }}
                  >
                    <span
                      style={{
                        fontSize: "14px",
                        fontWeight: 500,
                        color: "#111827",
                      }}
                    >
                      {faq.question}
                    </span>
                    <KeyboardArrowDownIcon
                      style={{
                        fontSize: "16px",
                        color: "#9ca3af",
                        transition: "transform 0.2s",
                        transform: open ? "rotate(180deg)" : "rotate(0deg)",
                        flexShrink: 0,
                      }}
                    />
                  </button>
                  {open && (
                    <p
                      style={{
                        marginTop: "8px",
                        fontSize: "14px",
                        color: "#4b5563",
                      }}
                    >
                      {faq.answer}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}

      <button
        type="button"
        onClick={() => setFaqOpen((v) => !v)}
        aria-expanded={faqOpen}
        aria-label="FAQ"
        style={{
          height: isMobile ? "48px" : "56px",
          width: isMobile ? "48px" : "56px",
          borderRadius: "50%",
          backgroundColor: "#3333ff",
          boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: "none",
          cursor: "pointer",
        }}
      >
        <img
          src={FaqIcon}
          alt=""
          style={{
            height: isMobile ? "48px" : "56px",
            width: isMobile ? "48px" : "56px",
            filter: "brightness(0) invert(1)",
          }}
        />
      </button>
    </div>
  );
}
